export default __webpack_public_path__ + "static/media/settings_1.4483ffc4.svg";